import { compose } from 'recompose';

import BreadCrumbs from './breadCrumbs';

const enhance = compose();

export default enhance(BreadCrumbs);
